export default __webpack_public_path__ + "static/media/PricingPage.c6e93374.jpeg";